import { IUserProfileLocalRepository, CustomError, UserProfile } from "../../index";

export class SetAboutHattrickLocalUserPercentageUseCase {
    private localRepository: IUserProfileLocalRepository;

    constructor(localRepository: IUserProfileLocalRepository) {
        this.localRepository = localRepository;
    }

    execute(percentage: number): UserProfile | CustomError {
        return this.localRepository.setAboutHattrickPercentage(percentage);
    }
}